<template>
  <div class="container-fluid" style="padding-left: 0px; padding-right: 0px;">
    <div class="pageContainer">
      <div class="row">
        <div class="col-sm-12">
          <div class="pageSubContainer">
            <div class="row">
              <div class="col-sm-12">
                <form name="add" @submit.prevent="updateOrder">
                <div class="pageCard">
                  <div class="row">
                      <div class="col-sm-6">
                        <div class="itemsGroup">
                          
                          
                          <div class="itemsList">
                            <dt class="item">Site Address</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select v-model="order.site_address_id">
                                  <option v-for="address in addresses" :key="address.id" :value="address.id" :selected="address.id === order.site_address_id">({{ address.label }}) {{ address.address1 }}, {{ address.address2 }}, {{ address.city }}, {{ address.county }}, {{ address.postcode }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                          <div class="itemsList">
                            <dt class="item">Asset</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select v-model="order.asset_id">
                                  <option v-for="asset in assets" :key="asset.id" :value="asset.id" :selected="asset.id === order.asset_id">({{ asset.serial }}) {{ asset.name }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                          <div class="itemsList">
                            <dt class="item">Engineer</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select v-model="order.engineer">
                                  <option value="Will Rae">Will Rae</option>
                                  <option value="Ben White">Ben White</option>
                                  
                                </select>
                              </div>
                            </dd>
                          </div>
                        </div>
                      </div>
                        <div class="col-sm-6">
        
                          <div class="itemsGroup">
                            <div class="itemsList">
                            <dt class="item">Contact</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select>
                                  <option v-for="contact in contacts" :key="contact.id" :value="contact.id" :selected="contact.id === order.contact_id">{{ contact.first_name }} {{ contact.last_name }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                            <div class="itemsList">
                              <dt class="item">Reference</dt>
                              <dd class="item"><input type="text" class="text" v-model="order.customer_reference" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Customer PO</dt>
                              <dd class="item"><input type="text" class="text" v-model="order.customer_po" /></dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Xero Invoice Number</dt>
                              <dd class="item"><input type="text" class="text" v-model="order.xero_invoice_number" /></dd>
                            </div>
                            
                          </div>
                        </div>
                      <div class="col-sm-4">
                        
                      </div>
                    </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <hr />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-12">
                     
        <!--<table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
            <tr>
                <td class="label" rowspan="3" width="20%">Equiptment</td>
                <td class="labelLight" width="20%">Name of plant</td>
                <td width="20%"><input type="text" /></td>
                <td class="labelLight" width="20%">Refrigerant Type</td>
                <td width="20%"><input type="text" /></td>
            </tr>
            <tr>
                <td class="labelLight">Make / Model</td>
                <td><input type="text" /></td>
                <td class="labelLight">Refrigerant Charge</td>
                <td><input type="text" /></td>
            </tr>
            <tr>
                <td class="labelLight">Serial</td>
                <td><input type="text" /></td>
                <td class="labelLight">Date</td>
                <td></td>
            </tr>
       </table>

       <div style="width: 100%; height: 30px;"></div>-->

       <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
          <tr>
              <td width="20%" style="border:0;">&nbsp;</td>
              <td width="30%" style="border:0;">&nbsp;</td>
              <td class="labelLight" width="10%">Comp 1</td>
              <td class="labelLight" width="10%">Comp 2</td>
              <td class="labelLight" width="10%">Comp 3</td>
              <td class="labelLight" width="10%">Comp 4</td>
              <td class="labelLight" width="10%">Comp 5</td>
          </tr>
          <tr>
              <td class="label" rowspan="16">Plant Checks</td>
              <td class="labelLight">Connections and condition of compressor</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_1" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_1" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_1" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_1" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_1" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Compressor oil</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_2" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_2" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_2" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_2" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_2" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Comp oil filter pressure</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_3" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_3" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_3" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_3" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_3" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Oil cooler fans</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_4" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_4" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_4" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_4" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_4" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Compressor contractors and overloads</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_5" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_5" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_5" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_5" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_5" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Oil coolers</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_6" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_6" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_6" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_6" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_6" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Condensor fans</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_7" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_7" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_7" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_7" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_7" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Liquid line filter dryer</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_8" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_8" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_8" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_8" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_8" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Subcooling</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_9" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_9" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_9" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_9" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_9" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Fan motor and blades</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_10" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_10" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_10" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_10" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_10" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Oil filter</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_11" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_11" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_11" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_11" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_11" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Suction filter</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_12" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_12" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_12" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_12" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_12" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Plant corrosion</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_13" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_13" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_13" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_13" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_13" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Compressor voltage</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_14" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_14" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_14" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_14" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_14" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">Compressor amps</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_15" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_15" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_15" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_15" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_15" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
          <tr>
              <td class="labelLight">RDM system checks</td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_1_16" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_2_16" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_3_16" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_4_16" value="Pass"><span class="checkmark"></span></label></td>
              <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.plant_5_16" value="Pass"><span class="checkmark"></span></label></td>
          </tr>
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0">
            <tr>
                <td class="label" width="20%">Comments</td>
                <td><textarea rows="5" v-model="refridgeration.plant_comments"></textarea></td>
            </tr>
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
            <tr>
                <td width="20%" style="border:0;">&nbsp;</td>
                <td width="30%" style="border:0;">&nbsp;</td>
                <td class="labelLight" width="10%">Cooler 1</td>
                <td class="labelLight" width="10%">Cooler 2</td>
                <td class="labelLight" width="10%">Cooler 3</td>
                <td class="labelLight" width="10%">Cooler 4</td>
                <td class="labelLight" width="10%">Cooler 5</td>
            </tr>
            <tr>
                <td class="label" rowspan="9">Evaporators Checks</td>
                <td class="labelLight">Evaporators</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_1_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_2_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_3_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_4_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_5_1" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Defrost heaters</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_1_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_2_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_3_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_4_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_5_2" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Expansion valves</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_1_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_2_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_3_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_4_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_5_3" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Hot gas defrost</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_1_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_2_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_3_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_4_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_5_4" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Control probes</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_1_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_2_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_3_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_4_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_5_5" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Solenoid valves</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_1_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_2_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_3_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_4_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_5_6" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Evaporator corrosion</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_1_7" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_2_7" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_3_7" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_4_7" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_5_7" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Saftey guards</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_1_8" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_2_8" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_3_8" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_4_8" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_5_8" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Fan motor and blades</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_1_9" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_2_9" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_3_9" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_4_9" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.evaporator_5_9" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0">
            <tr>
                <td class="label" width="20%">Comments</td>
                <td><textarea rows="5" v-model="refridgeration.evaporator_comments"></textarea></td>
            </tr>
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <div class="page-break"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
            <tr>
                <td width="20%" style="border:0;">&nbsp;</td>
                <td width="30%" style="border:0;">&nbsp;</td>
                <td class="labelLight" width="10%">Cooler 1</td>
                <td class="labelLight" width="10%">Cooler 2</td>
                <td class="labelLight" width="10%">Cooler 3</td>
                <td class="labelLight" width="10%">Cooler 4</td>
                <td class="labelLight" width="10%">Cooler 5</td>
            </tr>
            <tr>
                <td class="label" rowspan="7">Drains Checks</td>
                <td class="labelLight">Condition</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_1_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_2_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_3_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_4_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_5_1" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Termination point</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_1_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_2_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_3_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_4_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_5_2" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Drain heaters</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_1_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_2_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_3_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_4_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_5_3" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Drain trap clear</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_1_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_2_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_3_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_4_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_5_4" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Drain heater breakers</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_1_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_2_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_3_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_4_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_5_5" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Corrosion - internal</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_1_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_2_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_3_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_4_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_5_6" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Corrosion - external</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_1_7" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_2_7" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_3_7" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_4_7" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.drains_5_7" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0">
            <tr>
                <td class="label" width="20%">Comments</td>
                <td><textarea rows="5" v-model="refridgeration.drains_comments"></textarea></td>
            </tr>
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
            <tr>
                <td width="20%" style="border:0;">&nbsp;</td>
                <td width="30%" style="border:0;">&nbsp;</td>
                <td class="labelLight" width="10%">Pack</td>
                
            </tr>
            <tr>
                <td class="label" rowspan="8">Refrigerant Checks</td>
                <td class="labelLight">Refrigerant level check</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refrigerant_1_1" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
            <tr>
                <td class="labelLight">Discharge pressure</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refrigerant_1_2" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
            <tr>
                <td class="labelLight">Suction pressure</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refrigerant_1_3" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
            <tr>
                <td class="labelLight">Subcooling pressure</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refrigerant_1_4" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
            <tr>
                <td class="labelLight">Temperature</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refrigerant_1_5" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
            <tr>
                <td class="labelLight">Superheats</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refrigerant_1_6" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
            <tr>
                <td class="labelLight">Visual sight glasses</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refrigerant_1_7" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
            <tr>
                <td class="labelLight">Solenoid coils not cracked / burnt out</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refrigerant_1_8" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
       </table>

       <div class="page-break"></div>

       <div style="width: 100%; height: 30px;"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0">
            <tr>
                <td class="label" width="20%">Comments</td>
                <td><textarea rows="5" v-model="refridgeration.refrigerant_comments"></textarea></td>
            </tr>
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
            <tr>
                <td width="20%" style="border:0;">&nbsp;</td>
                <td width="30%" style="border:0;">&nbsp;</td>
                <td class="labelLight" width="10%">Comp 1</td>
                <td class="labelLight" width="10%">Comp 2</td>
                <td class="labelLight" width="10%">Comp 3</td>
                <td class="labelLight" width="10%">Comp 4</td>
                <td class="labelLight" width="10%">Comp 5</td>
            </tr>
            <tr>
                <td class="label" rowspan="4">Refridgeration Pressure Safetys</td>
                <td class="labelLight">Safety cut out test on HP switch</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_1_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_2_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_3_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_4_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_5_1" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Oil safety cut out test</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_1_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_2_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_3_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_4_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_5_2" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Pump down test on LP switches</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_1_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_2_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_3_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_4_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_5_3" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Pressure release valves</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_1_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_2_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_3_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_4_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.refridgeration_5_4" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0">
            <tr>
                <td class="label" width="20%">Comments</td>
                <td><textarea rows="5" v-model="refridgeration.refridgeration_comments"></textarea></td>
            </tr>
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
            <tr>
                <td width="20%" style="border:0;">&nbsp;</td>
                <td width="30%" style="border:0;">&nbsp;</td>
                <td class="labelLight" width="10%">Unit 1</td>
                <td class="labelLight" width="10%">Unit 2</td>
                <td class="labelLight" width="10%">Unit 3</td>
                <td class="labelLight" width="10%">Unit 4</td>
                <td class="labelLight" width="10%">Unit 5</td>
            </tr>
            <tr>
                <td class="label" rowspan="5">Electrics for evaporator control panels</td>
                <td class="labelLight">Mains incoming</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_1_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_2_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_3_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_4_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_5_1" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Fan contactor</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_1_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_2_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_3_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_4_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_5_2" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Defrost contactor</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_1_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_2_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_3_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_4_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_5_3" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Breakers</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_1_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_2_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_3_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_4_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_5_4" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Wire, cable and connections</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_1_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_2_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_3_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_4_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_5_5" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0">
            <tr>
                <td class="label" width="20%">Comments</td>
                <td><textarea rows="5" v-model="refridgeration.electrics_comments"></textarea></td>
            </tr>
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <div class="page-break"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000" >
            <tr>
                <td width="20%" style="border:0;">&nbsp;</td>
                <td width="30%" style="border:0;">&nbsp;</td>
                <td class="labelLight" width="10%">Unit 1</td>
                <td class="labelLight" width="10%">Unit 2</td>
                <td class="labelLight" width="10%">Unit 3</td>
                <td class="labelLight" width="10%">Unit 4</td>
                <td class="labelLight" width="10%">Unit 5</td>
            </tr>
            <tr>
                <td class="label" rowspan="6">Electrics for condensor unit</td>
                <td class="labelLight">Mains incoming</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_1_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_2_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_3_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_4_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_5_1" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Fan contactor</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_1_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_2_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_3_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_4_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_5_2" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Compressor contactor</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_1_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_2_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_3_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_4_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_5_3" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Breaker overloads</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_1_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_2_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_3_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_4_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_5_4" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Wire, cable and connections</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_1_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_2_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_3_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_4_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_5_5" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            <tr>
                <td class="labelLight">Fin corrosion</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_1_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_2_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_3_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_4_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.electrics_condensor_5_6" value="Pass"><span class="checkmark"></span></label></td>
            </tr>
            
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0">
            <tr>
                <td class="label" width="20%">Comments</td>
                <td><textarea rows="5" v-model="refridgeration.electrics_condensor_comments"></textarea></td>
            </tr>
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0" bordercolor="#000000">
            <tr>
                <td width="20%" style="border:0;">&nbsp;</td>
                <td width="26%" style="border:0;">&nbsp;</td>
                <td class="labelLight" width="26%">Floor transformers</td>
                <td class="labelLight" width="26%">Door heater</td>
                
            </tr>
            <tr>
                <td class="label" rowspan="6">Floor and door heaters</td>
                <td class="labelLight">Floor heater mat - check and test</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.heaters_1_1" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.heaters_2_1" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
            <tr>
                <td class="labelLight">Cold store 1 doors</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.heaters_1_2" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.heaters_2_2" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
            <tr>
                <td class="labelLight">Cold store 2 doors</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.heaters_1_3" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.heaters_2_3" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
            <tr>
                <td class="labelLight">Cold store 3 doors</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.heaters_1_4" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.heaters_2_4" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
            <tr>
                <td class="labelLight">Cold store 4 doors</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.heaters_1_5" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.heaters_2_5" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
            <tr>
                <td class="labelLight">Cold store 5 doors</td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.heaters_1_6" value="Pass"><span class="checkmark"></span></label></td>
                <td><label class="checkboxContainer"><input type="checkbox" v-model="refridgeration.heaters_2_6" value="Pass"><span class="checkmark"></span></label></td>
                
            </tr>
            
       </table>

       <div style="width: 100%; height: 30px;"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0">
            <tr>
                <td class="label" width="20%">Comments</td>
                <td><textarea rows="5" v-model="refridgeration.heaters_comments"></textarea></td>
            </tr>
       </table>

       

       <div class="page-break"></div>

       <table width="100%" border="1" cellpadding="0" cellspacing="0" style="margin-top: 30px;">
            <tr>
                <td class="label" width="20%">Recommendations / Advisories</td>
                <td><textarea rows="5" v-model="refridgeration.recommendations"></textarea></td>
            </tr>
       </table>

                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col-sm-12">
                      <hr />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-1">
                      
                    </div>
                    <div class="col-sm-3">
                     
                    </div>
                    <div class="col-sm-8">
                      <div align="right">
                        <input type="submit" value="Save Job">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                      <div class="col-sm-4">
                         <a @click.prevent="deleteJob()" class="btnRedText">Delete Job</a>
                      </div>
                      
                      <div class="col-sm-8">
                        
                      </div>
                    </div>
                </div>
              </form>
              </div>
              
              
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
            <div class="pageCard greenTop">
                <div class="row">
                    <div class="col-sm-12">
                        <h6>Reports</h6>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <!--<a class="btnOrderAction" @click.prevent="finaliseOrder()">Finalise <font-awesome-icon icon="angle-double-right" /></a>-->
                        <a href="#" @click.prevent="$openPdf('maintenance-checklist', order.id)" class="btnOrderAction">Large Maintenance Checklist <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                </div>
            </div>
        </div>

        
          <div class="col-sm-3" v-if="order.asset_id">
            <div class="pageCard greenTop">
              <div class="row">
                <div class="col-sm-12">
                  <h6>F-Gas Leak Check</h6>
                </div>
              </div>
              <div v-if="leak_check_view">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="itemsGroup">
                        <div class="itemsList">
                          <dt class="item">Test Result</dt>
                          <dd class="item"><input type="text" class="text" v-model="leakcheck.result" /></dd>
                        </div>
                        <div class="itemsList">
                          <dt class="item">Further Actions</dt>
                          <dd class="item"><input type="text" class="text" v-model="leakcheck.further" /></dd>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <a @click.prevent="leakTest()" class="btnOrderAction">Process <font-awesome-icon icon="angle-double-right" /></a>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row">
                  <div class="col-sm-12">
                    <p>I have performed an F-Gas Leak Check in accordance of EU 517/2014.</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <a @click.prevent="goLeakTest()" class="btnGreenLine" >Create Leak Check <font-awesome-icon icon="angle-double-right" /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3" v-if="order.asset_id">
            <div class="pageCard greenTop">
              <div class="row">
                <div class="col-sm-12">
                  <h6>F-Gas Movements</h6>
                </div>
              </div>
              <div v-if="addgas">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="itemsGroup">
                        <div class="itemsList">
                          <dt class="item">Amount added (Kg)</dt>
                          <dd class="item"><input type="text" class="text" v-model="fgasadd.amount_gas" /></dd>
                        </div>
                        <div class="itemsList">
                          <dt class="item">Reason for</dt>
                          <dd class="item"><input type="text" class="text" v-model="fgasadd.reason" /></dd>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-bottom: 15px;">
                  <div class="col-sm-12">
                    <a @click.prevent="addGas()" class="btnOrderAction">Process <font-awesome-icon icon="angle-double-right" /></a>
                  </div>
                </div>
              </div>
              <div v-if="removegas">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="itemsGroup">
                        <div class="itemsList">
                          <dt class="item">Amount removed (Kg)</dt>
                          <dd class="item"><input type="text" class="text" v-model="fgasremove.amount_gas" /></dd>
                        </div>
                        <div class="itemsList">
                          <dt class="item">Reason for</dt>
                          <dd class="item"><input type="text" class="text" v-model="fgasremove.reason" /></dd>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-bottom: 15px;">
                  <div class="col-sm-12">
                    <a @click.prevent="removeGas()" class="btnOrderAction">Process <font-awesome-icon icon="angle-double-right" /></a>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <a class="btnGreenLine" @click.prevent="goAddGas()" >Add Gas <font-awesome-icon icon="angle-double-right" /></a>
                </div>
                <div class="col-sm-6">
                  <a class="btnGreenLine" @click.prevent="goRemoveGas()" >Remove Gas <font-awesome-icon icon="angle-double-right" /></a>
                </div>
              </div>
            </div>
          </div>
        
        <div class="col-sm-3" v-if="order.status==='processing'">
            <div class="pageCard greenTop">
                <div class="row">
                <div class="col-sm-12">
                    <h6>Complete Job</h6>
                </div>
                </div>
                <div class="row">
                <div class="col-sm-12">
                    <a @click.prevent="completeOrder()" class="btnOrderAction" target="_blank" >Complete Job <font-awesome-icon icon="angle-double-right" /></a>
                </div>
                </div>
            </div>
        </div>
        <div class="col-sm-3" v-if="!order.invoice_status">
            <div class="pageCard greenTop">
                <div class="row">
                <div class="col-sm-12">
                    <h6>Invoice Job</h6>
                </div>
                </div>
                <div class="row">
                <div class="col-sm-12">
                    <a @click.prevent="invoiceOrder()" class="btnOrderAction" target="_blank" >Invoice Job <font-awesome-icon icon="angle-double-right" /></a>
                </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    
  </div>
</template>

<style type="text/css">
td {
            padding: 10px;
        }

        td.labelMain {
            text-transform: uppercase;
            background: #3FA582;
            color: #FFFFFF;
            font-weight: 600;
            font-family: "Arial", sans-serif !important;
        }

        td.label {
            text-transform: uppercase;
            background: #C6E0D8;
            font-weight: 600;
            font-size: 10px;
            font-family: "Arial", sans-serif !important;
        }

        td.labelLight {
            text-transform: uppercase;
            background: #eef6f4;
            font-weight: 600;
            font-size: 10px;
            font-family: "Arial", sans-serif !important;
        }
        
        td.label span {
            font-family: "Arial", sans-serif !important;
        }

        table {
            border: 1px solid;
            
        }
</style>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      companies: [],
      productInput: null,
      isVisible: false,
      variants: [],
      order: [],
      refridgeration: [],
      contacts: [],
      addresses: [],
      assets: [],
      leak_check_view: false,
      leakcheck: {},
      addgas: false,
      removegas: false,
      fgasadd: {},
      fgasremove: {},

    }
  },
  created () {
    axios
      .get(`/api/orders/${this.$route.params.id}`)
      .then((res) => {
        this.order = res.data.order
        axios
          .get(`/api/companies/${this.order.company_id}/contacts`)
          .then(response => {
            this.contacts = response.data
          })
        axios
          .get(`/api/companies/${this.order.company_id}/addresses`)
          .then(response => {
            this.addresses = response.data
          })
        axios
          .get(`/api/orders/${this.order.id}/maintenance`)
          .then(response => {
            this.refridgeration = response.data[0]
          })
        axios
          .get(`/api/companies/${this.order.company_id}/assets`)
          .then(response => {
            this.assets = response.data
          })
      })
    
  },
  watch: {
    productInput (after, before) {
      if (after === null || before === null) {
        this.DoNothing()
      } else {
        this.searchProduct()
      }
    }
  },
  methods: {
    onFocus: function () {
      this.isVisible = true
    },
    onBlur: function () {
      // this.isVisible = false
    },
    goLeakTest () {
      this.leak_check_view = true
    },
    leakTest () {

      this.leakcheck.asset_id = this.order.asset_id
      this.leakcheck.engineer = this.order.engineer
      this.leakcheck.type = 'Leak Check'

      axios
        .post('/api/fgas', this.leakcheck)
        .then(response => {
          this.$toast.success("Leak Check completed", {})
          this.leak_check_view = false
        })

    },
    goAddGas () {
      this.removegas = false
      this.addgas = true
    },
    goRemoveGas () {
      this.addgas = false
      this.removegas = true
    },
    addGas () {

      this.fgasadd.asset_id = this.order.asset_id
      this.fgasadd.engineer = this.order.engineer
      this.fgasadd.type = 'Addition'

      axios
        .post('/api/fgas', this.fgasadd)
        .then(response => {
          this.$toast.success("F-Gas Addition completed", {})
          this.addgas = false
        })

    },
    removeGas () {

      this.fgasremove.asset_id = this.order.asset_id
      this.fgasremove.engineer = this.order.engineer
      this.fgasremove.type = 'Removal'

      axios
        .post('/api/fgas', this.fgasremove)
        .then(response => {
          this.$toast.success("F-Gas Removal completed", {})
          this.removegas = false
        })

    },
    deleteJob () {
      if(confirm("Do you really want to delete this job?")){
      axios
        .delete(`/api/orders/${this.$route.params.id}`)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          this.$toast.success("Job deleted", {}),
          this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
      }
    },
    searchProduct () {
      const keywords = { keywords: this.productInput }
      axios
        .post('/api/variants/search', keywords)
        .then(response => {
          this.variants = response.data
        })
    },
    createOrder (variant) {
      const neworder = {
        variant_id: variant,
        company_id: this.order.company_id,
        currency: 'GBP',

        job_description: this.order.job_description,
        customer_reference: this.order.customer_reference,
      }
      axios
        .post('/api/orders/new', neworder)
        .then(response => {
          this.$router.push({ name: 'OrdersEdit', params: { id: response.data.id } })
        })
    },
    updateOrder () {

      axios
        .put(`/api/orders/${this.$route.params.id}`, this.order)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          axios
            .put(`/api/orders/${this.$route.params.id}/maintenance`, this.refridgeration)
            .then(response => (
              this.$toast.success("Job saved", {}),
              this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
            ))
            .catch(err => console.log(err))
            // .finally(() => this.loading = false)
         
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    completeOrder () {
      axios
        .put(`/api/orders/${this.$route.params.id}/actions/complete`, this.order)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          this.$toast.success("Job completed", {}),
          this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    invoiceOrder () {
      axios
        .put(`/api/orders/${this.$route.params.id}/actions/invoice`, this.order)
        .then(response => (
          //this.$router.push({ name: 'OrdersView', params: { id: this.$route.params.id } })
          this.$toast.success("Job invoiced", {}),
          this.$router.push({ name: 'Orders', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
      }
  },
  
  
}
</script>
